import gql from 'graphql-tag';
import FieldsLunchOption from "graphql/fields/FieldsLunchOption";

export default gql(`
	query lunch_options( $search: String ) {
		lunch_options( search: $search ) {
			${FieldsLunchOption}
		}
	}
`);

